import { authHeader } from "@roman/shared/lib/auth/authHeader";
import RomanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { CreateEntry } from "@roman/shared/types/CreateEntry";
import { useEffect } from "react";
import type { Key } from "swr";
import useSWRMutation from "swr/mutation";

type createEntryArg = {
  entryTx: CreateEntry;
};

const postCreateEntryRequest = async (url: string, { arg }: { arg: createEntryArg }) => {
  const headers = authHeader.getOrThrow();
  return await RomanApi.post(url, arg, { headers });
};

export const useCreateEntry = (handleError: (err: RomanApiError) => void) => {
  const { data, isMutating, trigger, error } = useSWRMutation<any, RomanApiError, Key, createEntryArg>(
    "/soccer/entry",
    (url: string, args: { arg: createEntryArg }) => postCreateEntryRequest(url, args),
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data,
    trigger,
    isMutating,
  };
};
